import { Registers } from './types';


export const registersAvailableStatuses = Object.values(Registers.Statuses)
    .filter(value => value !== Registers.Statuses.manualAnnulled);
